import { Dialog } from "primereact/dialog"
import ContaPagar from "../../model/contaPagar/ContaPagar"
import GerarBoletoResultSienge from "../../model/sienge/boleto/GerarBoletoResultSienge"
import { linhaDigitavelParaCodigoBarras, localDateStringToDate } from "../../utils/convert"
import { Button } from "primereact/button"
import { useToastContext } from "../../provider/ToastContext"
import { Copy, Download } from "lucide-react"
import { ReactBarcode, Renderer } from "react-jsbarcode"


type Props = {
    visible: boolean,
    boleto: GerarBoletoResultSienge | null,
    contaPagar: ContaPagar | null,
    onHide: () => void
}

export default function BoletoDialog({ visible, onHide, boleto, contaPagar }: Props) {
    const { msgSucesso } = useToastContext();

    const copiarCodigoDigitavel = () => {
        if (boleto?.digitableNumber) {
            navigator.clipboard.writeText(boleto.digitableNumber).then(() => {
                msgSucesso("Código copiado", "O código digitável foi copiado para a área de transferência.");
            });
        }
    }
    const downloadBoleto = () => {
        window.open(boleto?.urlReport, '_blank');
    };

    return (
        <Dialog
            header={"Boleto"}
            visible={visible}
            style={{ width: "50vw" }}
            breakpoints={{ "960px": "75vw", "640px": "95vw" }}
            onHide={() => onHide()}
        >
            <div className="flex flex-column gap-4">
                <div>
                    <h4 className="mb-2">Mensalidade - {contaPagar?.numeroParcela}</h4>
                    <p className="text-muted m-0">
                        Vencimento: {localDateStringToDate(contaPagar?.vencimento as unknown as string).toLocaleDateString("pt-BR")}
                    </p>
                    <p className="text-muted m-0">Valor: {contaPagar?.valorAtual.toLocaleString("pt-BR", { style: "currency", currency: "BRL" })}</p>
                </div>

                <div>
                    <label className="font-bold mb-2 block">Código Digitável:</label>
                    <div className="flex flex-column sm:flex-row align-items-stretch sm:align-items-center gap-2 p-3 border-1 surface-border border-round">
                        <span className="flex-1 font-mono" style={{ fontSize: "13px", wordBreak: "break-all" }}>
                            {boleto?.digitableNumber}
                        </span>
                        <Button
                            icon={<Copy size={16} />}
                            label="Copiar"
                            className="p-button-outlined p-button-sm"
                            onClick={() =>
                                copiarCodigoDigitavel()
                            }
                            tooltip="Copiar código"
                            tooltipOptions={{ position: "top" }}
                        />
                    </div>
                </div>

                <div>
                    <label className="font-bold mb-2 block">Código de Barras:</label>
                    <div className="p-3 border-1 surface-border border-round">
                        <div className="flex justify-content-center mb-2" style={{ overflowX: "auto" }}>
                            <ReactBarcode value={linhaDigitavelParaCodigoBarras(boleto?.digitableNumber||"")} options={{format: "ITF", displayValue: false}} renderer={Renderer.SVG} />
                        </div>
                    </div>
                </div>

                {/* Botão de Download */}
                <div className="flex justify-content-center mt-3">
                    <Button
                        icon={<Download size={18} />}
                        label="Baixar Boleto"
                        className="p-button-primary w-full sm:w-auto"
                        onClick={downloadBoleto}
                    />
                </div>

            </div>
        </Dialog>
    )
}